<script lang="ts">
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();
  import SingleDatePicker from "@shared/svelte/Components/SingleDatePicker.svelte";
  import moment from "moment";

  export let showTimePicker: boolean = true;
  export let testIdPrefix: string = "";

  // timestamp is in iso8601 format
  export let timestamp: string;
  export let timestampFormat: string = "iso";

  let dateValue;
  let timeValue: string;
  let timeValueInput: string;

  export let maxDateTimestamp: string = null;
  export let minDateTimestamp: string = null;

  let maxDateValue: Date;
  let minDateValue: Date;

  export let disabled: boolean = false;
  export let position: string = "";

  if (timestamp) {
    dateValue = moment(timestamp);
    timeValueInput = dateValue.format("HH:mm");
  }

  $: {
    if (maxDateTimestamp) {
      maxDateValue = new Date(maxDateTimestamp);
    } else {
      maxDateValue = null;
    }

    if (minDateTimestamp) {
      minDateValue = new Date(minDateTimestamp);
    } else {
      minDateValue = null;
    }
  }

  const updateTimestamp = () => {
    timeValue = timeValueInput;

    let [hours, minutes]: number[] = [0, 0];
    if (timeValue && timeValue.indexOf(":") > -1) {
      [hours, minutes] = timeValue.split(":").map(Number);
    } else {
      [hours, minutes] = [0, 0];
    }

    let oldTimestamp = timestamp;

    if (dateValue) {
      let res = moment(dateValue);

      if (timeValue) {
        res.hour(hours);
        res.minute(minutes);
      }

      res.seconds(0);
      res.milliseconds(0);

      if (timestampFormat == "iso") {
        timestamp = res.toISOString();
      } else {
        timestamp = res.format(timestampFormat);
      }
    } else {
      timestamp = null;
    }

    if (oldTimestamp !== timestamp) {
      dispatch("change", { timestamp });
    }
  };
</script>

<style>
  .time-picker-input:disabled {
    background: #eaeaea;
    cursor: not-allowed;
  }
</style>

<div data-testid="{testIdPrefix}-date-picker">
  <SingleDatePicker
    bind:startDate={dateValue}
    bind:disabled
    defaultButtonLabel={"Select date"}
    minWidth={"100%"}
    selectDateCallback={updateTimestamp}
    buttonMode={true}
    dateFormat={"MMM DD, YYYY"}
    maxDate={maxDateValue}
    minDate={minDateValue}
    {position}
  />
</div>

{#if showTimePicker}
  <div data-testid="{testIdPrefix}-time-picker">
    <input
      {disabled}
      class="fizz-input-text time-picker-input"
      on:change={updateTimestamp}
      type="time"
      bind:value={timeValueInput}
    />
  </div>
{/if}
